// react
// dependencies
import { List, Map } from "immutable";
import React from "react";
import { connect } from "react-redux";

import PageHeading from "../../components/PageHeading";
import PageTitle from "../../components/PageTitle";
import Spacer from "../../components/Spacer";
// constants
import Config from "./Config";

// components
import Directory from "../../containers/Directory";

import { useIsNewNavigation } from "../../api/hooks/defs/navigation";

import { ParseDepartments } from "../../actions/departments.actions";
import { ParseFields } from "../../actions/fields.actions";
// actions
import { StateChange } from "../../actions/page.actions";
import { SearchUsers } from "../../actions/users.actions";

import { getUserCompanyName } from "../../selectors/app";

import PropTypes from "../../lib/prop-types";

class CompanyDirectory extends React.Component {
	static propTypes = {
		changeState: PropTypes.func.isRequired,
		userIsAdmin: PropTypes.bool.isRequired,
		appHeight: PropTypes.number.isRequired,
		appWidth: PropTypes.number.isRequired,
		fields: PropTypes.instanceOf(List).isRequired,
		directoryFields: PropTypes.instanceOf(List).isRequired,
		isNewNav: PropTypes.bool,
	};

	constructor(props) {
		super(props);
		// set default values
		props.changeState(
			[],
			Map({
				currentPage: 1,
				columnWidths: Map(),
				fixedColumns: Map(),
				directoryFields: List([
					Map({
						name: "Name",
						_id: "_displayName",
						type: "_displayName",
					}),
				]),
			})
		);
	}

	render() {
		const { appHeight, appWidth, fields, directoryFields, userIsAdmin, isNewNav } = this.props;

		// set component heights
		const horizontalMargin = 20;
		const bodyHeight = appHeight - 20 - 20;
		const contentMaxWidth = 1304;
		const bodyWidth = isNewNav
			? Math.min(appWidth - horizontalMargin * 2, contentMaxWidth)
			: appWidth - horizontalMargin * 2;

		// set the columns
		const columns = fields.concat(directoryFields).map((item) => {
			// all dates from the custom fields are dumb dates -- i.e. the time
			// component should be ignored.
			if (item.get("type") === "date") {
				return item.set("type", "dumb-date");
			}

			return item;
		});

		const directory = (
			<Directory
				width={bodyWidth}
				height={bodyHeight}
				updateURLQuery={true}
				storeName={Config.pageName}
				showDownloadDirectoryLink={true}
				showChangeColumnLink={userIsAdmin}
				storeColumnWidthsInCookies={true}
				columns={columns}
			/>
		);

		return (
			<>
				<PageTitle
					title={`Directory${this.props.companyName ? ` - ${this.props.companyName}` : ""} - PerformYard`}
				/>
				<section className="react-page company-directory-page">
					<section className="page-inner-container" style={{ height: appHeight - 20 }}>
						{isNewNav ? (
							<div style={{ maxWidth: "var(--pyo-page-content-max-width, 1304px)", margin: "0 auto" }}>
								<Spacer height={3} />
								<PageHeading>Directory</PageHeading>
								<Spacer height={2} />
								{directory}
								<Spacer height={3} />
							</div>
						) : (
							directory
						)}
					</section>
				</section>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	const userIsAdmin = state.app.getIn(["user", "isAdmin"], false);

	return {
		userIsAdmin,
		companyName: getUserCompanyName(state),
		directoryFields: state.company.get("directoryFields"),
		appWidth: state.app.getIn(["appMeasurements", "width"]),
		appHeight: state.app.getIn(["appMeasurements", "height"]),
		fields: state.page.getIn([Config.pageName, "directoryFields"], List()),
	};
};

const mapDispatchToProps = (dispatch) => ({
	parseFields: (fields) => dispatch(ParseFields(fields)),
	searchUsers: (_ref = {}) => dispatch(SearchUsers(_ref)),
	parseDepartments: (departments) => dispatch(ParseDepartments(departments)),
	changeState: (keyPath, value) => dispatch(StateChange(Config.pageName, keyPath, value)),
});

const ConnectedCompanyDirectory = connect(mapStateToProps, mapDispatchToProps)(CompanyDirectory);

const CompanyDirectoryPage = (props) => {
	const isNewNav = useIsNewNavigation();
	return <ConnectedCompanyDirectory {...props} isNewNav={isNewNav} />;
};

export default CompanyDirectoryPage;
